import styled, {css} from "styled-components";
import {Button} from "../../../../../basic-ui-components/button/base/button.component";

export const ExploreButtonMrgreenBox = styled(Button)`
  ${props => css`
    background: linear-gradient(${props.theme.colors.brandPrimaryContrast}, ${props.theme.colors.brandPrimaryContrast})
    color: ${props.theme.colors.brandPrimary};
  `}
`;